<template>
  <div class="relative">
    <div
      class="hint-anchor flex flex-row items-center gap-1 semantic-tag tag-mute-01 text-sm ml-3 rtl:mr-3 rtl:ml-0 cursor-pointer font-[400]"
    >
      <div>{{ $t('AGENT_MGMT.HINT.ANCHOR') }}</div>
      <span class="material-symbols-outlined text-base/[16px] text-[#475569]">
        help
      </span>
    </div>
    <div
      class="hint-content w-[310px] bg-white absolute top-[calc(100%+10px)] left-[10px] rtl:left-[unset] rtl:right-[10px] p-4 rounded-[12px] border border-gray-100 shadow-lg z-[100]"
    >
      <div>
        <div class="text-lg font-bold text-gray-700 mb-1">
          {{ $t('AGENT_MGMT.HINT.TITLE') }}
        </div>
        <div class="text-xs font-[400] text-gray-500">
          {{ $t('AGENT_MGMT.HINT.DESC') }}
        </div>
      </div>
      <hr class="border-gray-200" />
      <div>
        <div class="mb-5 text-sm font-semibold text-gray-400">
          {{ $t('AGENT_MGMT.HINT.ROLES_LABEL') }}
        </div>
        <div class="space-y-4">
          <div
            v-for="item in hintItems"
            :key="item.key"
            class="flex flex-row gap-2"
          >
            <div
              class="w-8 min-w-[32px] h-8 flex justify-center items-center rounded-[8px]"
              :class="item.bgColor"
            >
              <span
                class="material-symbols-outlined font-[300]"
                :class="item.iconColor"
              >
                {{ item.icon }}
              </span>
            </div>
            <div>
              <div class="mb-1 text-sm text-gray-700 font-semibold">
                {{ item.title }}
              </div>
              <div class="text-xs text-gray-600 font-[400]">
                {{ item.description }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const HINT_ITEM_ICONS = [
  {
    key: 'GENERAL_MANAGER',
    icon: 'crown',
    iconColor: 'text-[#EF4444] text-[20px]',
    bgColor: 'bg-red-50',
  },
  {
    key: 'ADMIN',
    icon: 'support_agent',
    iconColor: 'text-purple-500 text-[18px]',
    bgColor: 'bg-purple-100',
  },
  {
    key: 'SHIFT_MANAGER',
    icon: 'admin_panel_settings',
    iconColor: 'text-green-500 text-[18px]',
    bgColor: 'bg-green-100',
  },
  {
    key: 'MARKETING',
    icon: 'campaign',
    iconColor: 'text-[#F59E0B] text-[18px]',
    bgColor: 'bg-[#FFFBEB]',
  },
  {
    key: 'AGENT',
    icon: 'group',
    iconColor: 'text-[#3B82F6] text-[18px]',
    bgColor: 'bg-blue-100',
  },
];
export default {
  computed: {
    hintItems() {
      return HINT_ITEM_ICONS.map(item => ({
        ...item,
        title: this.$t(`AGENT_MGMT.HINT.ROLES.${item.key}.TITLE`),
        description: this.$t(`AGENT_MGMT.HINT.ROLES.${item.key}.DESC`),
      }));
    },
  },
};
</script>

<style lang="scss">
.hint-anchor {
  ~ .hint-content {
    @apply hidden;
  }

  &:hover {
    ~ .hint-content {
      @apply block;
    }
  }
}
</style>
